module.exports = __webpack_public_path__ + "static/media/10_r_meshki_63.65_87.41.2522a917.png";